import { types } from "../action-types";

// import initialState from './appReducer';
const initialState = {
  loading: false,
  matched: [],
  skillset: [],
  error: {},
  success:false,
  singleMatchLoading:false,
  batchMatchLoading:false,

};

const MatchedSkillReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_SKILL_MACTHES_REQUESTED:
      return {
        ...state,
        matched: [],
        loading: true,
      };
    case types.GET_SKILL_MACTHES_SUCCESS:
      return {
        ...state,
        loading: false,
        matched: action.payload,
        skillset: Object.entries(action.payload.other_matches),
        error: false,
      };
    case types.GET_SKILL_MACTHES_FAILURE:
      return {
        ...state,
        loading: false,
        matched: [],
        error: true,
      };
    case types.Remove_Bidded_skillListings:
      const temp = action.payload.payload.bids;
      const skills = temp?.map((obj) => obj.SkillListingId);
      let filteredArray;
      if (state?.matched?.other_matches?.length) {
        filteredArray = state?.matched?.other_matches.filter(
          (obj) => !skills.includes(obj?.skill_listing?.SkillListingId)
        );
      }
      return {
        ...state,
        matched: filteredArray
          ? { other_matches: filteredArray }
          : state.matched,
      };
    ////////////////////////////
    case types.ADD_TO_MATCHES_REQUESTED:
      return {
        ...state,
        loading: true,
        success: false,
      };

    case types.ADD_TO_MATCHES_SUCCESS:
      return {
        ...state,
        loading: false,
        matched: action.payload,
        // skillset: Object.entries(action.payload.other_matches),
        error: false,
        success: true,
      };
    case types.ADD_TO_MATCHES_FAILURE:
      return {
        ...state,
        loading: false,
        matched: [],
        error: true,
        success: false,
      };

    ////////////////////////////////////////

    case types.REMOVE_FROM_MATCHES_REQUESTED:
      return {
        ...state,
        loading: true,
        success: false,
      };

    case types.REMOVE_FROM_MATCHES_SUCCESS:
      return {
        ...state,
        loading: false,
        matched: action.payload,
        // skillset: Object.entries(action.payload.other_matches),
        error: false,
        success: true,
      };
    case types.REMOVE_FROM_MATCHES_FAILURE:
      return {
        ...state,
        loading: false,
        matched: [],
        error: true,
        success: false,
      };

    case types.CLEAR_MATCHES_SUCCESS:
      return {
        ...state,
        success: false,
      };
    case types.ADD_SINGLE_MATCHES_REQUESTED:
      return {
        ...state,
        singleMatchLoading: true,
      };
    case types.ADD_SINGLE_MATCHES_SUCCESS:
      return {
        ...state,
        singleMatchLoading: false,
      };
    case types.ADD_SINGLE_MATCHES_FAILURE:
      return {
        ...state,
        singleMatchLoading: false,
      };
    case types.ADD_BATCH_MATCHES_REQUESTED:
      return {
        ...state,
        batchMatchLoading: true,
      };
      case types.ADD_BATCH_MATCHES_SUCCESS:
      return {
        ...state,
        batchMatchLoading: false,
      };
    case types.ADD_BATCH_MATCHES_FAILURE:
      return {
        ...state,
        batchMatchLoading: false,
      };

    default:
      return state;
  }
};

export default MatchedSkillReducer;
